module.exports = __webpack_public_path__ + "static/media/pabloTelescope.45d45f4a.png";